<template>
  <div class="d-flex text--primary flex-row align-center metric">
    <div>
      <label class="text--primary metric-description">{{ label }}:</label>
    </div>
    <div class="mb-2">
      <label v-if="!loading" class="text--primary font-weight-bold text-h6"><slot /></label>
      <v-skeleton-loader v-if="loading" type="table-cell"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "CurrentMonthPerformanceStats",
  props: {
    label: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped>

</style>